/**
 * Rota de uma tela de fase futura.
 *
 * Uma rota por item de menu, todas vindas da MESMA lista que monta a sidebar
 * (features/workspace/navigation.ts). É assim que se garante a invariante de
 * navegação: não existe item de menu sem rota nem rota sem item de menu.
 */
import { EmptyState, Card } from '@mgdlead/ui';

import { PhaseScreen } from '../../components/PhaseScreen';
import { navItemById } from '../../features/workspace/navigation';
import { useDocumentTitle } from '../../lib/useDocumentTitle';

export interface PhaseRouteProps {
  itemId: string;
}

export function PhaseRoute({ itemId }: PhaseRouteProps) {
  const item = navItemById(itemId);
  useDocumentTitle(item?.label ?? 'Tela não encontrada');

  if (!item) {
    return (
      <Card padded={false}>
        <EmptyState
          kind="no-data"
          title="Tela não encontrada"
          description="Este endereço não corresponde a nenhuma tela do painel."
        />
      </Card>
    );
  }

  return <PhaseScreen item={item} />;
}
